<app-login-layout>
  <form
  autocomplete="off"
  class="loginForm ng-valid ng-dirty ng-touched"
  #formLogin="ngForm"
  (ngSubmit)="onSubmit()"
  novalidate
>
<div class="LinkSolucionesLogo">
  <!-- <img src="/assets/img/marca hostel HR.png" class="m-auto"/> -->
  <img src="/assets/img/marca Lives color - alta.png" class="m-auto"/>
</div>

  <ng-container *ngIf="!companies || companies.length == 1">
    <div class="loginEmailBox">
      <div class="floatingLabelControl">

        <div class="floatingLabelContainer">
          <div
            class="horizontalLayout floatingLabel floatingLabelShown alignVerticalMiddle"
            id="labelLayout"
          >
            <label class="colAuto">Email</label>
          </div>
        </div>

        <div class="inputLabelContent" id="contentLayout">
          <input
            matInput
            [(ngModel)]="userName"
            name="userName"
            required
            #user="ngModel"
            [ngClass]="{ 'is-invalid': formLogin.submitted && user.invalid }"
          />
          <div *ngIf="formLogin.submitted && user.invalid" class="invalid-feedback">
            <div *ngIf="user.errors.required">
              El email es obligatorio.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loginPasswordBox">
      <div class="floatingLabelControl">

        <div class="floatingLabelContainer">
          <div
            class="horizontalLayout floatingLabel floatingLabelShown alignVerticalMiddle"
            id="labelLayout"
          >
            <label class="colAuto">Contraseña</label>
          </div>
        </div>

        <div class="inputLabelContent" id="contentLayout">
          <input
            matInput
            [type]="passwordVisible ? 'text' : 'password'"
            [(ngModel)]="password"
            name="password"
            required
            #pass="ngModel"
            [ngClass]="{ 'is-invalid': formLogin.submitted && pass.invalid }"
            style=" padding-right: 2em;"
          />
          <span class="toggle-password" (click)="passwordVisible = !passwordVisible">
            <mat-icon>{{ passwordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
          </span>
          <div *ngIf="formLogin.submitted && pass.invalid" class="invalid-feedback">
            <div *ngIf="pass.errors.required">
              La contraseña es obligatoria.
            </div>
          </div>

        </div>
      </div>
    </div>
  <div class="loginRecoveryPass">
        <a
          (click) = "passwordRecoveryOnClick()"
        >Recuperar contraseña</a>
      </div>
    <div class="loginSesionButton">

      <button class="buttonPrimary loadingAnimationButton" [className]="loading ? 'loadingAnimationButton' : ''" id="btnLogin" type="submit" [disabled]="loading">
        <ng-container *ngIf="!loading">Iniciar sesión</ng-container>
        <div class="loadingSpinner" *ngIf="loading"></div>
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="companies && companies.length > 1">
    <div class="floatingLabelControl">
      <div class="floatingLabelContainer">
        <div
          class="horizontalLayout floatingLabel floatingLabelShown alignVerticalMiddle"
          id="labelLayout"
        >
          <label class="colAuto">Empresa</label>
        </div>
      </div>
      <mat-form-field>
      <mat-select [(ngModel)]="companyId" name="companyId" >
        <mat-option *ngFor="let company of companies" [value]="company.companyCode">
            {{ company.companyName }}
        </mat-option>
      </mat-select>
      </mat-form-field>
    </div>

    <div class="loginSesionButton">
      <button class="buttonPrimary" id="btnContinuar"  [className]="loading ? 'loadingAnimationButton' : ''" type="submit" (click)="btnContinuarOnClick()" [disabled]="!companyId || loading">
        <ng-container *ngIf="!loading">Continuar</ng-container>
        <div class="loadingSpinner" *ngIf="loading"></div>
      </button>
    </div>
  </ng-container>
  </form>
</app-login-layout>
